import * as ACTION from "../components/GlobalAddTriggerModal/actions/globalTriggerActionTypes";

const initialState = {
    isAddingTriggerFolder: false,
    isUpdatingTriggerFolder: false,
    isDeletingTriggerFolder: false,
    gettingTriggerFolder: false,
    triggerFolderList: [],
    permissionDeniedModal: {
        openPermissionDeniedModal: false,
        permissionDeniedModalTitle:'',
        permissionDeniedModalAction:'',
    },
    triggerParams: {
        page: 1,
        limit: 20,
        search: null,
        created_by: null,
        user_trigger_folder_id: null,
        privacy_level: 0,
    },
    isAddingTrigger: false,
    isUpdatingTrigger: false,
    isDeletingTrigger: false,
    gettingTrigger: true,
    triggerList: [],
    hasMoreTriggerData: false,
    isUpdatingTriggerStatus: false,
    isDuplicatingTrigger: false,
};

const globalTriggerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION.ADD_TRIGGER_FOLDER:
            return {
                ...state,
                isAddingTriggerFolder: true,
            };
        case ACTION.ADD_TRIGGER_FOLDER_SUCCESS:
            return {
                ...state,
                isAddingTriggerFolder: false,
                triggerFolderList: [
                    ...state.triggerFolderList,
                    action.payload,
                ],
            };
        case ACTION.ADD_TRIGGER_FOLDER_FAILURE:
            return {
                ...state,
                isAddingTriggerFolder: false,
            };
        case ACTION.GET_TRIGGER_FOLDER:
            return {
                ...state,
                gettingTriggerFolder: true,
            };
        case ACTION.GET_TRIGGER_FOLDER_SUCCESS:
            return {
                ...state,
                gettingTriggerFolder: false,
                triggerFolderList: action.payload,
            };
        case ACTION.GET_TRIGGER_FOLDER_FAILURE:
            return {
                ...state,
                gettingTriggerFolder: false,
            };
        case ACTION.UPDATE_TRIGGER_FOLDER:
            return {
                ...state,
                isUpdatingTriggerFolder: true,
            };
        case ACTION.UPDATE_TRIGGER_FOLDER_SUCCESS:
            return {
                ...state,
                isUpdatingTriggerFolder: false,
                triggerFolderList: state.triggerFolderList.map((folder) =>
                    folder.id === action.payload.id
                        ? {
                              ...folder,
                              name: action.payload.name,
                              folder_color: action.payload.folder_color,
                              folder_icon: action.payload.folder_icon,
                          }
                        : folder
                ),
            };
        case ACTION.UPDATE_TRIGGER_FOLDER_FAILURE:
            return {
                ...state,
                isUpdatingTriggerFolder: false,
            };
        case ACTION.DELETE_TRIGGER_FOLDER:
            return {
                ...state,
                isDeletingTriggerFolder: true,
            };
        case ACTION.DELETE_TRIGGER_FOLDER_SUCCESS:
            return {
                ...state,
                isDeletingTriggerFolder: false,
                triggerFolderList: state.triggerFolderList.filter(
                    (folder) => folder.id !== action.payload.id
                ),
            };
        case ACTION.DELETE_TRIGGER_FOLDER_FAILURE:
            return {
                ...state,
                isDeletingTriggerFolder: false,
            };
        case ACTION.HANDLE_PERMISSION_DENIED_MODAL:
            return {
                ...state,
                permissionDeniedModal:{
                    ...state.permissionDeniedModal,
                    openPermissionDeniedModal:action.payload.openPermissionDeniedModal,
                    permissionDeniedModalTitle:action.payload.permissionDeniedModalTitle,
                    permissionDeniedModalAction:action.payload.permissionDeniedModalAction
                }
            };
        case ACTION.HANDLE_SELECTED_FOLDER:
            return {
                ...state,
                triggerParams: {
                    ...state.triggerParams,
                    user_trigger_folder_id: action.payload,
                    page: 1
                },
            };
        case ACTION.HANDLE_TRIGGER_PRIVACY_LEVEL:
            return {
                ...state,
                triggerParams: {
                ...state.triggerParams,
                privacy_level: action.payload,
                page: 1,
                created_by: null
                },
            };
        
        case ACTION.HANDLE_TRIGGER_SEARCH:
        return {
            ...state,
            triggerParams: {
            ...state.triggerParams,
            search: action.payload,
            page: 1
            },
        };
        
        case ACTION.HANDLE_USER_WISE_FILTER:
        return {
            ...state,
            triggerParams: {
            ...state.triggerParams,
            created_by: action.payload,
            page: 1
            },
        };

        case ACTION.ADD_TRIGGER:
            return {
                ...state,
                isAddingTrigger: true,
            };
        case ACTION.ADD_TRIGGER_SUCCESS:
            return {
                ...state,
                isAddingTrigger: false,
            };
        case ACTION.ADD_TRIGGER_FAILURE:
            return {
                ...state,
                isAddingTrigger: false,
            };
        case ACTION.GET_TRIGGER:
            return {
                ...state,
                gettingTrigger: true,
            };
        case ACTION.GET_TRIGGER_SUCCESS:
            return {
                ...state,
                gettingTrigger: false,
                triggerList: state.triggerParams.page === 1 ?
                 action.payload : 
                 [...state.triggerList, ...action.payload],
                 hasMoreTriggerData: action.payload.length === state.triggerParams.limit
            };
        case ACTION.GET_TRIGGER_FAILURE:
            return {
                ...state,
                gettingTrigger: false,
                triggerList: [],
            };
        case ACTION.RECALL_TRIGGER:
            return {
                ...state,
                triggerParams:{
                    ...state.triggerParams,
                    user_trigger_folder_id: action.payload.user_trigger_folder_id ? action.payload.user_trigger_folder_id : state.triggerParams.user_trigger_folder_id,
                    privacy_level: action.payload.privacy_level,
                    search: null,
                    created_by: null,
                    page: 1
                }
            };
        case ACTION.GET_TRIGGER_MORE_DATA:
            return {
                ...state,
                triggerParams: {
                    ...state.triggerParams,
                    page: state.triggerParams.page + 1
                },
                hasMoreTriggerData: false
            };
        case ACTION.UPDATE_TRIGGER:
            return {
                ...state,
                isUpdatingTrigger: true,
            };
        case ACTION.UPDATE_TRIGGER_SUCCESS:
            return {
                ...state,
                isUpdatingTrigger: false,
            };
        case ACTION.UPDATE_TRIGGER_FAILURE:
            return {
                ...state,
                isUpdatingTrigger: false,
            };
        case ACTION.DELETE_INSURANCE_TRIGGER:
            return {
                ...state,
                isDeletingTrigger: true,
            };
        case ACTION.DELETE_INSURANCE_TRIGGER_SUCCESS:
            return {
                ...state,
                isDeletingTrigger: false,
                triggerList: state.triggerList.filter(
                    (trigger) => trigger.id !== action.payload.id
                ),
            };
        case ACTION.DELETE_INSURANCE_TRIGGER_FAILURE:
            return {
                ...state,
                isDeletingTrigger: false,
            };
        case ACTION.UPDATE_TRIGGER_STATUS:
            return {
                ...state,
                isUpdatingTriggerStatus: true,
                triggerList: state.triggerList.map((trigger) => {
                    if (trigger.id === action.payload.triggerRuleId) {
                        return {
                            ...trigger,
                            tempStatus: trigger.status,
                            status: action.payload.status,
                        };
                    }
                    return trigger;
                })
            };

        case ACTION.UPDATE_TRIGGER_STATUS_SUCCESS:
            return {
                ...state,
                isUpdatingTriggerStatus: false,
            };

        case ACTION.UPDATE_TRIGGER_STATUS_FAILURE:
            return {
                ...state,
                isUpdatingTriggerStatus: false,
                triggerList: state.triggerList.map((trigger) => {
                    if (trigger.id === action.payload.triggerRuleId) {
                        return {
                            ...trigger,
                            status: trigger.tempStatus,
                        };
                    }
                    return trigger;
            })};
        case ACTION.DUPLICATE_INSURANCE_TRIGGER:
            return {
                ...state,
                isDuplicatingTrigger: true,
            };
        case ACTION.DUPLICATE_INSURANCE_TRIGGER_SUCCESS:
            return {
                ...state,
                isDuplicatingTrigger: false,
            };
        case ACTION.DUPLICATE_INSURANCE_TRIGGER_FAILURE:
            return {
                ...state,
                isDuplicatingTrigger: false,
            };

        default:
            return state;
    }
}


export default globalTriggerReducer;
